import React, { useState } from "react";


import {
  FaLandmark,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function PublicSectorGovernmentPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Governance & Citizen Services",
      points: [
        "Public Query Chatbot Agent",
        "Grievance Redressal Tracker",
        "Scheme Eligibility Screener",
        "Tax Filing Assistant Agent",
        "Voter Registration Assistant",
      ],
    },

    {
      title: "Policy & Administration",
      points: [
        "Budget Planning Forecast Agent",
        "Resource Allocation Optimizer",
        "Policy Sentiment Analysis Agent",
        "Election Sentiment Bot",
        "Citizen Poll Analyzer",
      ],
    },

    {
      title: "Urban & Rural Development",
      points: [
        "Smart City Data Orchestrator",
        "Land Dispute Resolution Agent",
        "Sanitation Monitoring Agent",
        "Water Resource Level Analyzer",
        "Road Maintenance Planner Agent",
      ],
    },

    {
      title: "Healthcare & Emergency",
      points: [
        "Health Record Verifier Agent",
        "Vaccination Alert System",
        "Ambulance Routing Optimizer",
        "Epidemic Spread Forecast Agent",
        "Public Health Sentiment Monitor",
      ],
    },

    {
      title: "Safety & Law Enforcement",
      points: [
        "Crime Pattern Analyzer Agent",
        "Identity Fraud Checker",
        "FIR Registration Chatbot",
        "Traffic Violation Detector Agent",
        "CCTV Footage Incident Identifier",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .publicsector-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .publicsector-hero {
          background: #173b8f;
          width: 100%;
        }

        .publicsector-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .publicsector-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .publicsector-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .publicsector-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .publicsector-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .publicsector-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .publicsector-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .publicsector-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .publicsector-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .publicsector-card-header.active {
          background: #173b8f;
        }

        .publicsector-card-header.inactive {
          background: #ffffff;
        }

        .publicsector-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .publicsector-card-title.active {
          color: #ffffff;
        }

        .publicsector-card-title.inactive {
          color: #173b8f;
        }

        .publicsector-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .publicsector-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .publicsector-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .publicsector-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .publicsector-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .publicsector-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .publicsector-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .publicsector-hero-inner {
            padding: 32px 0px;
          }

          .publicsector-title {
            font-size: 30px;
          }

          .publicsector-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .publicsector-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .publicsector-icon-box {
            width: 40px;
            height: 40px;
          }

          .publicsector-icon-box svg {
            font-size: 18px;
          }

          .publicsector-title {
            font-size: 26px;
          }

          .publicsector-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .publicsector-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .publicsector-card-header {
            padding: 12px 16px;
          }

          .publicsector-card-title {
            font-size: 15px;
          }

          .publicsector-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .publicsector-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .publicsector-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .publicsector-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .publicsector-icon-box svg {
            font-size: 16px;
          }

          .publicsector-title {
            font-size: 21px;
          }

          .publicsector-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .publicsector-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .publicsector-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .publicsector-card-header {
            padding: 10px 14px;
          }

          .publicsector-card-title {
            font-size: 14px;
          }

          .publicsector-card-content {
            padding: 14px 14px;
          }

          .publicsector-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .publicsector-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .publicsector-point-check svg {
            font-size: 9px;
          }

          .publicsector-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .publicsector-title {
            font-size: 18px;
          }

          .publicsector-card-title {
            font-size: 13px;
          }

          .publicsector-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="publicsector-wrapper">
        {/* HERO SECTION */}
        <div className="publicsector-hero">
          <div className="publicsector-hero-inner">
            <div className="publicsector-hero-top">
              <div className="publicsector-icon-box">
                <FaLandmark />
              </div>

              <h1 className="publicsector-title">
                Public Sector / Government
              </h1>
            </div>

            <p className="publicsector-description">
              This sector includes government agencies, public service departments, and administrative bodies delivering civic services, governance, and infrastructure.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="publicsector-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="publicsector-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`publicsector-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`publicsector-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="publicsector-chevron-active" />
                  ) : (
                    <FaChevronDown className="publicsector-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="publicsector-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="publicsector-point-row">
                        <div className="publicsector-point-check">
                          <FaCheck />
                        </div>

                        <p className="publicsector-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default PublicSectorGovernmentPage;
